import React, { useState, useRef } from 'react';
import CreateVendor from '../vendors/CreateVendor';
import Steps from '../../../components/steps/Steps';
import styles from '../../../assets/css/vendors/steps_vendor.module.css';
import Button from '../../../components/button/Button';
import next from '../../../assets/img/next.svg';
import images from '../../../assets/images';
import { useNavigate } from 'react-router-dom';

function ViewCreateVendor() {
    const [step, setStep] = useState(0);
    const [flag, setFlag] = useState(false);
    const [init, setInit] = useState(false);
    const navigation = useNavigate();

    const ViewInit = () => {
        return (
            <>
                <Steps
                    steps={mySteps}
                    title={'Create Vendor Profile'}
                    stylesTitle={styles.titleStep}
                />
                <div className={styles.vendor_body}>
                    <div className={styles.container}>
                        <div className={`${styles.margin} ${styles.text_left}`}>
                            <h5 style={{ fontWeight: 600 }}>
                                Payment Required
                            </h5>
                            <p>
                                After setting up your company profile, you will
                                be asked to submit payment for your company’s
                                subscription.
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                Payment is required before a vendor profile can
                                be published.
                            </p>
                            <p>&nbsp;</p>
                            <div className={styles.content_buttons_init}>
                                <Button
                                    text={'Cancel'}
                                    classs={'btnOutlineMain'}
                                    color={'grayLight'}
                                    marginRight={true}
                                    customStyle={styles.customStyle}
                                    onClick={() => cancel()}
                                />

                                <Button
                                    text={'Create profile'}
                                    classs={'btnMain'}
                                    alignImg="right"
                                    icon={next}
                                    onClick={() => initStepper(true)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const ViewMedia = () => {
        return (
            <div className={`${styles.container} ${styles.block}`}>
                <div className={styles.margin}>
                    <p className={styles.note}>Note: This step is optional</p>
                    <p>Upload profile picture.</p>
                    <p className={styles.subtitle}>
                        This is the photo that will be displayed next to your
                        name everywhere in the app.
                    </p>
                    <div className={styles.container}>
                        <div className={styles.circle_plus}>+</div>
                    </div>
                    <p>Upload cover picture.</p>
                    <p className={styles.subtitle}>
                        This is a large image that will be displayed at the top
                        of your profile.
                    </p>
                </div>
                <div className={styles.container_rectangle}>
                    <div className={styles.rectangle_plus}>+</div>
                </div>
            </div>
        );
    };
    const ViewAbout = () => {
        return (
            <div className={styles.container}>
                <div className={styles.margin}>
                    <p className={styles.note}>Note: This step is optional</p>
                    <p>Write an About section describing your business.</p>
                    <p className={styles.subtitle}>
                        This description will be placed on your public profile
                        for all to see.
                    </p>
                    <div className={styles.container_rectangle}>
                        <div className={styles.rectangle}>
                            <textarea
                                name="textarea"
                                rows="5"
                                cols="50"
                                className={`${styles.note} ${styles.margin_top}`}>
                                Our company’s mission is to...
                            </textarea>
                        </div>
                    </div>
                    <p>
                        Upload resources for others to access when they visit
                        your profile.
                    </p>
                    <p className={styles.subtitle}>
                        The resource, its caption, and date it was uploaded will
                        be visible for all to see under the Resources section of
                        your profile.
                    </p>
                    <div className={`${styles.container} ${styles.block}`}>
                        <div className={styles.center}>
                            <div className={styles.rectangle_min}></div>
                            <p>Upload Photo</p>
                        </div>
                        <span />
                        <br></br>
                        <div className={styles.center}>
                            <div className={styles.rectangle_min}></div>
                            <p>Upload Document</p>
                        </div>
                        <span />
                    </div>
                </div>
            </div>
        );
    };
    const ViewTier = () => {
        return (
            <div className={`${styles.container} ${styles.text_left}`}>
                <div className={styles.margin}>
                    <p>
                        Please activate your subscription.<span>*</span>
                    </p>
                    <p className={styles.note}>
                        You may change or cancel your subscription at any time.
                    </p>
                    <div className={styles.rows}>
                        <div className={styles.radio_vertical_center}>
                            <input type="radio" name="myradio" />
                        </div>
                        <div className={styles.border_container}>
                            <h5 style={{ fontWeight: 600 }}>Subscription</h5>
                            <p className={styles.subtitle}>
                                Your Company Will have a live profile within the
                                provider directory.
                            </p>
                            <p>
                                You will be able to update your profile at any
                                time with new information and resources.
                            </p>
                            <p>
                                Additionally, you will have access to all of
                                CampfireSocial’s features including creating and
                                responding to posts using your company’s name,
                                networking with potential buyers, and showcasing
                                your content through the community feed and
                                groups.
                            </p>
                            <h5 style={{ fontWeight: 600 }}>
                                Price: x.xx/month
                            </h5>
                        </div>
                    </div>
                    <br></br>
                    <p>Additional Tier subscription options coming soon!</p>
                </div>
            </div>
        );
    };
    const ViewPayment = () => {
        return (
            <div className={`${styles.container}`}>
                <div className={styles.margin}>
                    <p className={`${styles.title} ${styles.font_size16}`}>
                        Thanks for creating your vendor profile!
                    </p>
                    <span className={styles.no_margin} />
                    <div className={styles.block}>
                        <br />
                        <p className={styles.subtitle}>
                            {`Payment is under construction so we'll be sending you an
                            old school invoice for now. Stay tuned for more
                            information on how to start paying online.`}
                        </p>
                        <br />
                        <p className={styles.subtitle}>
                            Have questions? Email us at
                            billing@campfiresocial.io.
                        </p>
                        <br />
                        <p className={styles.subtitle}>
                            {`We'll see you at our campfire!`}
                        </p>
                    </div>
                    <br />
                </div>
            </div>
        );
    };
    const ViewConfirm = () => {
        return (
            <div className={`${styles.container} ${styles.block}`}>
                <div className={styles.margin}>
                    <p className={`${styles.title} ${styles.font_size16}`}>
                        Congratulations!
                    </p>
                    <span />
                    <img
                        src={images.check}
                        alt={'logo'}
                        className={`${styles.margin_top} ${styles.icon_check}`}></img>
                    <div className={styles.padding_horizontal}>
                        <p className={styles.subtitle}>
                            You are now active as a vendor profile.
                        </p>
                        <p className={styles.subtitle}>
                            Any time you post, comment, or interact with other
                            users and content, you will be acting as your
                            company.
                        </p>
                        <p className={styles.subtitle}>
                            You can switch back to your personal profile any
                            time through Profile.
                        </p>
                    </div>
                </div>
            </div>
        );
    };
    const mySteps = [
        {
            index: 1,
            name: 'Name',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [
                {
                    label: 'Vendor Contact First Name',
                    placeholder: 'Your first name',
                    required: true,
                    type: 'text',
                    name: 'name'
                },
                {
                    label: 'Vendor Contact Last Name',
                    placeholder: 'Your last name',
                    required: true,
                    type: 'text',
                    name: 'last_name'
                },
                {
                    label: 'Vendor Contact Title',
                    placeholder: 'Ex. VP of Marketing',
                    required: false,
                    type: 'text',
                    name: 'contact'
                },
                {
                    label: 'Vendor Languages Spoken',
                    placeholder: '0 Selected',
                    required: false,
                    type: 'select',
                    name: 'language',
                    data: [
                        { name: 'English' },
                        { name: 'French' },
                        { name: 'German' },
                        { name: 'Italian' }
                    ],
                    checkRefs: useRef([])
                }
            ]
        },
        {
            index: 2,
            name: 'Contact',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [
                {
                    label: 'Company Web Address',
                    placeholder: 'https://campfiresocial.io',
                    required: true,
                    type: 'text',
                    name: 'web'
                },
                {
                    label: 'Vendor Email Address',
                    placeholder: 'Janedoe@email.com',
                    required: true,
                    type: 'email',
                    name: 'email'
                },
                {
                    label: 'Vendor Phone Number',
                    placeholder: '1234567890',
                    required: true,
                    type: 'number',
                    name: 'celphone',
                    code: 1
                },
                {
                    label: 'Company Address',
                    placeholder: '1212 Sunset Blvd',
                    required: false,
                    type: 'text',
                    name: 'address1'
                },
                {
                    label: 'Address Line 2',
                    placeholder: '',
                    required: false,
                    type: 'text',
                    name: 'address2'
                },
                {
                    label: 'Country',
                    placeholder: '0 Selected',
                    required: false,
                    type: 'select',
                    name: 'country',
                    data: [
                        { name: 'United States' },
                        { name: 'Afghanistan' },
                        { name: 'Aland Islands' },
                        { name: 'Albania' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'City',
                    placeholder: '0 Selected',
                    required: false,
                    type: 'select',
                    name: 'city',
                    data: [
                        { name: 'pending 1' },
                        { name: 'pending 2' },
                        { name: 'pending 3' },
                        { name: 'pending 4' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'State',
                    placeholder: '0 Selected',
                    required: false,
                    type: 'select',
                    name: 'state',
                    data: [
                        { name: 'Alabama' },
                        { name: 'Alaska' },
                        { name: 'Arizona' },
                        { name: 'Arkansas' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'Zip Code',
                    placeholder: '36043',
                    required: false,
                    type: 'number',
                    name: 'zipcode'
                }
            ]
        },
        {
            index: 3,
            name: 'Details',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [
                {
                    label: 'Business Categories',
                    placeholder: 'Select all that apply',
                    required: false,
                    type: 'select',
                    name: 'business',
                    data: [
                        { name: 'Distributor' },
                        { name: 'Food Service' },
                        { name: 'Information Technology' },
                        { name: 'Investing' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'Markets',
                    placeholder: 'Select all that apply',
                    required: true,
                    type: 'select',
                    name: 'markets',
                    data: [
                        { name: 'Corporate' },
                        { name: 'Education' },
                        { name: 'Healthcare' },
                        { name: 'Nonprofits' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'Regions Served',
                    placeholder: 'Select all that apply',
                    required: true,
                    type: 'select',
                    name: 'regions',
                    data: [
                        { name: 'United States' },
                        { name: 'Afghanistan' },
                        { name: 'Aland Islands' },
                        { name: 'Albania' }
                    ],
                    checkRefs: useRef([])
                },
                {
                    label: 'Solutions',
                    placeholder: 'Select all that apply',
                    required: true,
                    type: 'select',
                    name: 'solutions',
                    data: [
                        { name: 'Afterschool Programs' },
                        { name: 'Career and Higher Education' },
                        { name: 'Community' },
                        { name: 'Government Advocacy' }
                    ],
                    checkRefs: useRef([])
                }
            ]
        },
        {
            index: 4,
            name: 'Media',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [],
            view: <ViewMedia />
        },
        {
            index: 5,
            name: 'About',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [],
            view: <ViewAbout />
        },
        {
            index: 6,
            name: 'Tier',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [],
            view: <ViewTier />
        },
        {
            index: 7,
            name: 'Payment',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [],
            view: <ViewPayment />
        },
        {
            index: 8,
            name: 'Confirm',
            background: styles.selected,
            selectedText: styles.selected_text,
            myRefs: useRef([]),
            formList: [],
            view: <ViewConfirm />
        }
    ];
    const cancel = () => {
        navigation(-1);
    };
    const nextStep = next => {
        setFlag(true);
        next ? setStep(step + 1) : setStep(step - 1);
    };

    const initStepper = next => {
        next ? setInit(true) : setInit(false);
    };

    return init ? (
        <>
            <Steps
                step={step}
                steps={mySteps}
                title={'Create Vendor Profile'}
                stylesTitle={styles.titleStep}
            />
            {/* This is the complement to create vendor */}
            <CreateVendor
                step={step}
                steps={mySteps}
                nextStep={nextStep}
                flag={flag}
                backHome={() => initStepper()}
            />
        </>
    ) : (
        <ViewInit />
    );
}

export default ViewCreateVendor;
